/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};


function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}
function setCookie(name, value, days) {
  	if(days == null)
      days = 2;
  
    var d = new Date;
    d.setTime(d.getTime() + 24*60*60*1000*days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}
function isWholesaleCustomer(){
	return (window.shopifyCustomer != null && window.shopifyCustomer.includes("Netrition_WholesaleY"));
}
function updateRebuySubTotalSavingText(savingmoneytext){
  if (savingmoneytext != null) {
	document.querySelector(".rebuy-cart__flyout-subtotal-label span").innerHTML = "Subtotal <span class='cc_savings'>(You save <span class='money'>"+ savingmoneytext + "</span>)</span>";
  } else {
  	document.querySelector(".rebuy-cart__flyout-subtotal-label span").innerHTML = "Subtotal";
  }
}
function rechargeWidgetCallback()
{
	if(document.querySelector(".rc-subscription-details .rc-subscription-details__button span") != null){

        console.log("New widget");
		document.querySelector(".rc-subscription-details .rc-subscription-details__button span").innerText="";

        document.querySelector(".rc-subscription-details .rc-subscription-details__button span").classList.add("fa");

        document.querySelector(".rc-subscription-details .rc-subscription-details__button span").classList.add("fa-question-circle");

      	var rstate = Recharge.widgets[document.querySelectorAll("form[data-productid].product-form")[0].attributes['data-productid'].value].state;
    	var currentSelectedVariant = rstate.variant;
      	if(rstate.sellingPlan != undefined){
      		// first time load
          	var allVariants= Recharge.widgets[document.querySelectorAll("form[data-productid].product-form")[0].attributes['data-productid'].value].product.variants;
            var currentSelectedVariant = rstate.variant;
            var curVariant = allVariants.find(s=>s.id == currentSelectedVariant);
            	var disct = 0;
                if(parseFloat(curVariant.prices.compare_at_price) > 0){
                    disct = parseFloat(curVariant.prices.compare_at_price) - parseFloat(curVariant.prices.discounted_price);
                    document.querySelector(".product-meta__label-list span.product-label.product-label--on-sale").innerHTML = 'Save <span>' + Shopify.formatMoney((parseFloat(disct) * 100), $('body').data('money-format')) + '</span>';
                }

                // display subscription price = curVariant.prices.discounted_price
                document.querySelectorAll(".current_price")[0].innerText = Shopify.formatMoney((parseFloat(curVariant.prices.discounted_price) * 100), $('body').data('money-format'));                
          
      	}
      
      	var radios = document.querySelectorAll('.rc-widget [type=radio][name=purchaseOption]');
        radios.forEach(radio => radio.addEventListener('change', () => 
        {
            var allVariants= Recharge.widgets[document.querySelectorAll("form[data-productid].product-form")[0].attributes['data-productid'].value].product.variants;
            var currentSelectedVariant = Recharge.widgets[document.querySelectorAll("form[data-productid].product-form")[0].attributes['data-productid'].value].state.variant
            var curVariant = allVariants.find(s=>s.id == currentSelectedVariant);
            if(radio.value=="onetime")
            {
                var disct = 0;
                if(parseFloat(curVariant.prices.compare_at_price) > 0){
                    disct = parseFloat(curVariant.prices.compare_at_price) - parseFloat(curVariant.prices.unit_price);
                    document.querySelector(".product-meta__label-list span.product-label.product-label--on-sale").innerHTML = 'Save <span>' + Shopify.formatMoney((parseFloat(disct) * 100), $('body').data('money-format')) + '</span>';
                }
                // display price = curVariant.prices.unit_price
                document.querySelectorAll(".current_price")[0].innerText = Shopify.formatMoney((parseFloat(curVariant.prices.unit_price) * 100), $('body').data('money-format'));
            }else{
                var disct = 0;
                if(parseFloat(curVariant.prices.compare_at_price) > 0){
                    disct = parseFloat(curVariant.prices.compare_at_price) - parseFloat(curVariant.prices.discounted_price);
                    document.querySelector(".product-meta__label-list span.product-label.product-label--on-sale").innerHTML = 'Save <span>' + Shopify.formatMoney((parseFloat(disct) * 100), $('body').data('money-format')) + '</span>';
                }

                // display subscription price = curVariant.prices.discounted_price
                document.querySelectorAll(".current_price")[0].innerText = Shopify.formatMoney((parseFloat(curVariant.prices.discounted_price) * 100), $('body').data('money-format'))
            }

        }));
      
    }
}

(function(){

  setTimeout(function(){
    if(typeof yotpo == "object"){
    	//yotpo.refreshWidgets();
      	//yotpo.initWidgets();
    }
    // fix for Activate Customer popup
    if(document.querySelector("div#AAI-buttontext a") != null)
    	document.querySelector("div#AAI-buttontext a").attributes.href.value = "javascript:void(0)"
    if(document.querySelector("#AAI-cancel a") != null)
    	document.querySelector("#AAI-cancel a").attributes.href.value = "javascript:void(0)"
        
    
  },2000);
  
  	if(isWholesaleCustomer())
  	{
      	document.body.classList.add('norebuycart');
      	document.body.classList.remove('nominicart');
    }
  
  
  if(theme.pageType == 'product') {
  	setTimeout(rechargeWidgetCallback,2000);
    setTimeout(rechargeWidgetCallback,3000);
  }
  
  
})();



function removeSmartCartForWholeSale(){
	if(isWholesaleCustomer())
  	{
      	document.body.classList.add('norebuycart');
      	document.body.classList.remove('nominicart');
  		// disbale the Rebuy SMARTCART	
    	window.Rebuy.SmartCart.destroy();
    	window.Rebuy.SmartCart.unbindEvents();
    
  	}
}
function rebuySmartCartAfterChangeUpdates(cartData){  
  
  if(window.Rebuy.SmartCart.cart != null){
    		var total_savings = 0;
            var discounted_price_total = 0;
        		
    		window.Rebuy.SmartCart.cart.items.filter(function(citm){
              
              if(JSON.parse(localStorage.getItem("v" + citm.variant_id)) == null){
              	$.ajax({
                    dataType: "json",
                    async: false,
                    cache: false,
                    url: "/products/" + citm.handle + ".js",
                    success: function(data) {
                      var variant_id = citm.variant_id;
                      var variant = $.grep(data.variants, function(v) {
                        return v.id == variant_id;
                      });

                      localStorage.setItem("v"+variant_id, JSON.stringify({ compare_at_price : variant[0].compare_at_price }));
                      if(variant[0] && variant[0].compare_at_price > citm.price) {                        
                        discounted_price_total += citm.price * citm.quantity;
                        total_savings += variant[0].compare_at_price * citm.quantity;
                      }
                    }
                  });
                }else{
                  // found in localstorage. 
                  var vitemzero = JSON.parse(localStorage.getItem("v" + citm.variant_id));
                  if(vitemzero && vitemzero.compare_at_price > citm.price) {                        
                      discounted_price_total += citm.price * citm.quantity;
                      total_savings += vitemzero.compare_at_price * citm.quantity;
                  }                
              	}   
                
            });
    
    	if (total_savings > 0) {              
        	updateRebuySubTotalSavingText(Shopify.formatMoney(total_savings - discounted_price_total, $('body').data('money-format')));
        } else {              
        	updateRebuySubTotalSavingText(null);
        }  
    
  }
  
}


document.addEventListener('rebuy.init', function(event){
  	console.log('rebuy.init event', event.detail);  	

    // Call cold pack provinces
    checkColdPackStates();

});
document.addEventListener('rebuy:smartcart.ready', function(event){ 
  console.log('rebuy:smartcart.ready event', event.detail);
  //removeSmartCartForWholeSale();
  
  setTimeout(function(){ removeSmartCartForWholeSale();  },2000);
  
}); 
document.addEventListener('rebuy.change', function(event){ 
  console.log('rebuy.change event', event.detail); 
	//removeSmartCartForWholeSale();
}); 

document.addEventListener('theme:quickview:opened', function(event){ 
  if(typeof yotpo != "undefined")
  {
  	yotpo.initWidgets();
  }
}); 


document.addEventListener('theme:sliderpopup:opened', function(event){ 
  console.log('theme:sliderpopup:opened', event.detail); 
  if(typeof Tawk_API == "object")
  		Tawk_API.hideWidget();
  
  if(typeof __attentive == "object"){
  	__attentive.hide();
  }
  
}); 
document.addEventListener('theme:sliderpopup:closed', function(event){ 
  console.log('theme:sliderpopup:closed', event.detail); 
  if(typeof Tawk_API == "object")
  		Tawk_API.showWidget();
  
  if(typeof __attentive == "object"){
  	__attentive.show();
  }
  
}); 

document.addEventListener('rebuy:cart.change', function(event){
    	setTimeout(function(){
    	
          if(document.querySelectorAll(".rebuy-cart__flyout-integration div.minordernotice").length > 1){
            	document.querySelectorAll(".rebuy-cart__flyout-integration div.minordernotice").forEach(function(itm, index){ if(index > 0){ itm.remove();  } });
          }
          
          // Hide checkout button.
          if(document.querySelector(".rebuy-cart__flyout-actions") != null && Rebuy.SmartCart.cart != null){
            
            if(parseFloat(document.body.attributes.minorder.value) > Rebuy.SmartCart.cart.total_price/100){
              document.querySelector(".rebuy-cart__flyout-actions").classList.add("minorderrequired");
              
              if(document.querySelector(".rebuy-cart__flyout-integration div.minordernotice") != null)
                  document.querySelector(".rebuy-cart__flyout-integration div.minordernotice").style.display = "block";
            }else{
              
              document.querySelector(".rebuy-cart__flyout-actions").classList.remove("minorderrequired");
              if(document.querySelector(".rebuy-cart__flyout-integration div.minordernotice") != null)
                  document.querySelector(".rebuy-cart__flyout-integration div.minordernotice").style.display = "none";
            }
          }
          if(window.Rebuy.SmartCart.cart != null){
          	// UPDATE THEME'S CART ITEM COUNT
    		document.querySelector(".header__cart-count").innerText = window.Rebuy.SmartCart.cart.item_count;
          }
          
          if(isWholesaleCustomer() == false){
          	if(window.theme.cartattributeupdate != true){
                //console.log("is wholesale customer heatsnsitive fired");
            	heatSensitiveService();
            }else{
              window.theme.cartattributeupdate = false;
            }
          }
          
          rebuySmartCartAfterChangeUpdates(event);
          
          	if (typeof window.bppayLaterFunction.refreshCartHtmls == "function")
            {
              window.bppayLaterFunction.refreshCartHtmls();
            }
          
        },300);
});


document.addEventListener("variant:changed", function(e){

    
    if(e.detail == null || e.detail.variant == null){
      console.log("variant:changed fired in customjs", "DETAIL OBJ NULL");  
      setTimeout(function(){ document.querySelector("form a.klaviyo-bis-trigger").style.display = "none"; },100); 
    }
  	// for quick view - out of stock notify form's visibility.  	
  	if(e.detail.variant != null &&  e.detail.variant.available)
  		$(".modal__dialog .product-form__payment-container div.notify_form").hide();
  	else if(e.detail.variant != null)
      	$(".modal__dialog .product-form__payment-container div.notify_form").show();
      
});

document.addEventListener("mobile:menu:opened", function(e){
     // hide Tawk chat plugin
  	if(typeof Tawk_API == "object")
  		Tawk_API.hideWidget();
});

document.addEventListener("mobile:menu:closed", function(e){
     // show Tawk chat plugin
  if(typeof Tawk_API == "object")
  		Tawk_API.showWidget();
});

async function checkColdPackStates()
  {
    console.log('before start');

        // Set local variable for state allowed for ColdPack service.
      var geoLoc  =  await Rebuy.getGeolocation()
      console.log(geoLoc);
      if(geoLoc.country_code == "US" && (window.theme.cart_cold_allowedstateabb.includes(geoLoc.province_code))){
          window.theme.IsColdPackSbbAllowed = true;
      }else{
        window.theme.IsColdPackSbbAllowed = false;
      }
  
  console.log('after start');
  }

function addColdServiceNoticeToDrawer(){

  /*--  coldnoticebutton div is placed in Rebuy SAMRT Cart Widget, only visible based on below code -- */
  document.querySelector(".rebuy-cart__flyout-integration #coldnoticebutton").classList.remove("mehidden");
  	/*<div id="coldnoticebutton">
		<a data-tooltip="Your order contains heat-sensitive items. We highly recommend choosing to add the Cold Pack Service to your order. If you decline cold pack service you accept the risk of heat-damaged products." class="rebuy-button block" title="Your order contains heat sensitive items. We highly recommend choosing to add the Cold Pack Service to your order. " style="background: #d44b3c;border-color: #d44b3c;cursor: pointer;"> Add Cold Pack Service - $3.99</a> 
	</div>*/
    	
}
function removeColdServiceNoticeToDrawer(){
  if(document.querySelector(".rebuy-cart__flyout-integration #coldnoticebutton") != null)
  	document.querySelector(".rebuy-cart__flyout-integration #coldnoticebutton").classList.add("mehidden");    	
}

function addColdPackServiceInCart(forceAdd)
{
              setCookie("coldserviceadded" + Rebuy.Cart.cart.token,1);
                
                  var addData = {
                    'id':window.theme.cart_cold_service_product_vid, 
                    'quantity':1,
                    'properties': {
                           '_Offer': 'FREE'
                     }
                  };

                  fetch(window.routes.cartAddUrl + '.js', {
                    body: JSON.stringify(addData),
                    credentials: 'same-origin',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                    },
                    method: 'POST'
                  }).then(function(response) {
                    return response.json();
                  }).then(function(json) {
                    /* we have JSON */
                    console.log("---- HEAT SENSITIVE COLD-SERVICE ADDED",json)

                    setCookie("csautoadd" + Rebuy.Cart.cart.token,1);                    
                      if(forceAdd == true){
                        removeColdServiceNoticeToDrawer();
                        window.theme.cartattributeupdate=true;
                        updateCartAttributeColdPackRemoved("ADDED");
                      }
                    
                    	document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        	bubbles: true
                      	}));
                    
                  }).catch(function(err) {
                    /* uh oh, we have error. */
                    console.error(err)
                    	document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                        	bubbles: true
                      	}));
                    
                  });

  return false;
}

function heatSensitiveService(forceAdd)
{
  	removeColdServiceNoticeToDrawer();
    var itmttl = 0;
    window.coldpackrequire = false; // used only in this method.
	window.Rebuy.Cart.getItems().forEach(function(p, index){ 
          	var phandle = p.handle;
      		fetch("/products/"+ phandle +".json").then(s=>s.json()).then(function(data){ 
              
              itmttl++;
              if(data.product.tags.includes("Collection_Heat Sensitive"))
              {
                window.coldpackrequire = true;
                setCookie("coldservicerequired",1);
                var yesExists = window.Rebuy.Cart.getItems().find(s=>s.handle == window.theme.cart_cold_service_product_handle);
                if(yesExists != null){
                	setCookie("coldserviceadded" + Rebuy.Cart.cart.token,1);
                  	removeColdServiceNoticeToDrawer();
                  	
                }else if (forceAdd != true && forceAdd != null && getCookie("coldserviceadded" + Rebuy.Cart.cart.token) == "1") {
                  // Customer intensionally removed this cold pack item. So add RED button again.
                  // add div to rebuy drawer.
                  addColdServiceNoticeToDrawer();
                  updateCartAttributeColdPackRemoved("REMOVED");
                  setCookie("coldserviceadded" + Rebuy.Cart.cart.token,0);
                } else {
                  	setCookie("coldserviceadded" + Rebuy.Cart.cart.token,0);
                  
                  	// add div to rebuy drawer.
                  	addColdServiceNoticeToDrawer();
                }

                
                if(getCookie("csautoadd" + Rebuy.Cart.cart.token) == "1" && forceAdd != true){
                    return;
                }
                
                var ctotal = window.Rebuy.Cart.subtotal() / 100;
                
                if((forceAdd == true || parseFloat(window.theme.cart_cold_service_amount) <= ctotal)  && (getCookie("coldserviceadded" + Rebuy.Cart.cart.token) != "1") 
                   && yesExists == null)
                {
              		// Yes cart have heat sensitive item, add extra service product. 
                    addColdPackServiceInCart();
                    removeColdServiceNoticeToDrawer();
                }
              }

              if(itmttl == window.Rebuy.Cart.getItems().length && window.coldpackrequire == false && 
                 getCookie("coldserviceadded" + Rebuy.Cart.cart.token) == "1") {
                  // COLD SHOT NOT REQUIRED. & PREENT IN CART. SO REMOVE IT.
                  var removeData = { 'id': window.theme.cart_cold_service_product_vid, 'quantity': 0 }; 
                  fetch('/cart/change.js', {
                    body: JSON.stringify(removeData),
                    credentials: 'same-origin',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With':'xmlhttprequest' 
                    },
                    method: 'POST'
                  }).then(s=>s.json()).then(function(data){
                      window.theme.cartattributeupdate=true;
                      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
                  });
              }
              
            });    
		})
    
    return true;
}

function buttonSubmitNotifyMeKlaviyo(ctrl)
{
  	var pdiv = $(ctrl).closest(".notify-custom");
	var klvkey = "RHdejJ";
  	var cemail = $(pdiv).find("#txtEmail").val();  	
  	var variantid = $(pdiv).attr("data-vid");
  if(cemail == ""){ 
    $("div.modal[aria-hidden='false'] .modal__inner  .responseMsg").html("Please enter email address.");
    return false;
  }
  
  		$.ajax({
          type: "GET",
          url: "https://appbundle.bariatricpal.com/GenMisc/CallKlaviyoBISAlert?emailaddr=" + cemail + "&variantid=" + variantid + "&acctkey=" + klvkey,
          success: function (data) {
            var dt = JSON.parse(data);
            if(dt.success == true){
    			$("div.modal[aria-hidden='false'] .modal__inner  .responseMsg").html("Thanks! You will get a notification when it's back in stock.");
            }else{
            	$("div.modal[aria-hidden='false'] .modal__inner  .responseMsg").html("There was something wrong with your request. Please try later.");
            }
            
          },
          error: function(data) {
            console.error(data);
            $("div.modal[aria-hidden='false'] .modal__inner .responseMsg").html("Alert service down. Sorry for any Inconvenience.");
          }
        });  
  
}


function updateCartAttributeColdPackRemoved(parAction)
{
                 var addData = {
                    'attributes': {
                           '_COLDPACK': 'CUSTOMER ' + parAction
                     }
                  };

                  fetch('/cart/update.js', {
                    body: JSON.stringify(addData),
                    credentials: 'same-origin',
                    headers: {
                      'Content-Type': 'application/json',
                      'X-Requested-With':'xmlhttprequest' 
                    },
                    method: 'POST'
                  }).then(function(response) {
                    return response.json();
                  }).then(function(json) {
                    /* we have JSON */
                    console.log("---- COLD-SERVICE ATTRIBUTE EXECUTED " + parAction ,json)
                    window.theme.cartattributeupdate=true;
                    
                  }).catch(function(err) {
                    /* uh oh, we have error. */
                    console.error(err)
                    
                  });
    
}

/*KLARNA SHOPAY ICONS SETUP SCRIPT */    

  (function(){
  
    var bppayLaterFunction = function(){
    
      var cls = {
        
        settings : {
          productpage_containerdivid: "#payLaterButtons",
          productpage_initialprice : ".product-block-list__item--info .eleSezzelPrice .current_price.price",
          cartpage_totamamt_element: ".rebuy-cart__flyout-subtotal-amount",
          cartpage_containerdiv: ".rebuy-cart__flyout-subtotal", // this will be append below this target
          defaultPreText : "or 4 interest-free payments of ",
          pppricepaylater1 : "#pppricepaylater1",
          carttotalpaylater1 : "#ctppaylater1",
          defaultPriceText : "<b>Sale price $<span id='pppricepaylater1'></span></b>",
          defaultCartTotalText : "<b> $<span id='ctppaylater1'></span></b>",
          defaultImgIconsEndpart : " with <button type='button' class='popup-trigger' data-popup-trigger='pafterpay'> <img class='afterpay-logo ap-modal-info-link' src='https://cdn.shopify.com/s/files/1/0806/1189/files/ap-logo-widget.png?v=1651310904' alt='Afterpay' style='max-height: 30px; vertical-align: middle;'> ⓘ</button> or " + ' <img class="sezzle-shoppay-logo no-sezzle-info" src="https://cdn.shopify.com/s/files/1/0806/1189/files/shoppay.svg?v=1627557113" alt="Shop pay" /><button type="button" title="Learn More about Shop pay" class="klarna-modal-info-link no-sezzle-info shoppayicon" onclick="shopapayclick()">ⓘ</button>',
          defaultCARTDRAWERImgIconsEndpart : " with  <button type='button' class='popup-trigger' data-popup-trigger='pafterpay'> <img class='afterpay-logo ap-modal-info-link' src='https://cdn.shopify.com/s/files/1/0806/1189/files/ap-logo-widget.png?v=1651310904' alt='Afterpay' style='max-height: 30px; vertical-align: middle;'> ⓘ</button> or " + ' <img class="sezzle-shoppay-logo no-sezzle-info" src="https://cdn.shopify.com/s/files/1/0806/1189/files/shoppay.svg?v=1627557113" alt="Shop pay" /><button type="button" title="Learn More about Shop pay" class="klarna-modal-info-link no-sezzle-info shoppayicon" onclick="shopapayclick()">ⓘ</button>'
          
        },
        initProductPage : function(){        	
          	// recreate the html text inside product page div, if found.
          if(document.querySelector(this.settings.productpage_containerdivid))
          {
          	document.querySelector(this.settings.productpage_containerdivid).innerHTML =  this.settings.defaultPreText + this.settings.defaultPriceText + this.settings.defaultImgIconsEndpart;            
            
            document.querySelector(this.settings.pppricepaylater1).innerHTML = this.getProductPagePriceEMI();
           
            
            // bind Variant change event            
            document.addEventListener("variant:changed", function(e){              
              setTimeout(function(){
              		window["bppayLaterFunction"].reBindOnVariantChangeProductpage();
                	window["bppayLaterFunction"].popupInitializations();
              },1000);
            });
            
            
          }
        },
        initCartDrawerPage : function(){     
          
          	// recreate the html text inside product page div, if found.
          if(document.querySelector(this.settings.cartpage_containerdiv))
          {
            var d = document.createElement("div");
            d.className = "payLaterButtons";
            d.id = "cartpayLaterButtons";
            
          	d.innerHTML =  this.settings.defaultPreText + this.settings.defaultCartTotalText + this.settings.defaultCARTDRAWERImgIconsEndpart;            
           
            document.querySelector(window.bppayLaterFunction.settings.cartpage_containerdiv).after(d);
            
            var cartemi = this.getCartTotalForEMI();
            if(isNaN(cartemi)){
            	document.querySelector(window.bppayLaterFunction.settings.carttotalpaylater1).innerHTML = "0.00";
            }else
            {
            	document.querySelector(this.settings.carttotalpaylater1).innerHTML = this.getCartTotalForEMI();
            }
            
          }
        },
        refreshCartHtmls : function(){
          	if(document.querySelector(this.settings.carttotalpaylater1)){
              	var cartemi = this.getCartTotalForEMI();
              	if(isNaN(cartemi)){
              		document.querySelector(window.bppayLaterFunction.settings.carttotalpaylater1).innerHTML = "0.00";
                }else{
        			document.querySelector(this.settings.carttotalpaylater1).innerHTML = this.getCartTotalForEMI();
                }
            }else{
            	window["bppayLaterFunction"].initCartDrawerPage();
              	window["bppayLaterFunction"].popupInitializations();
              
            }
        },
        reBindOnVariantChangeProductpage:function(){
        
          if(document.querySelector(this.settings.productpage_containerdivid))
          {
          	document.querySelector(this.settings.productpage_containerdivid).innerHTML =  this.settings.defaultPreText + this.settings.defaultPriceText + this.settings.defaultImgIconsEndpart;            
            
            document.querySelector(this.settings.pppricepaylater1).innerHTML = this.getProductPagePriceEMI();           
         }
        },
        getCartTotalForEMI: function(){
        
        	return (parseFloat((parseFloat(document.querySelector(this.settings.cartpage_totamamt_element).innerText.replace("$", "")) * 100) / 4) / 100).toFixed("2");
        },
        getProductPagePriceEMI: function(){
        	var amt = document.querySelector(this.settings.productpage_initialprice).innerText.split("$")[1];
        	return (parseFloat((parseFloat(amt.replace("$", "")) * 100) / 4) / 100).toFixed("2");
        },
        addPopupModalHtmls:function(){
        
          //klarna image url, klarna link
          var htmlStr= '<div class="bpplbody-blackout"></div>';
          // Popup for Afterpay
          htmlStr += '<div class="bpplpopup-modal shadow" data-popup-modal="pafterpay"><i class="bpplpopup-modal__close"><svg focusable="false" class="icon icon--close " viewBox="0 0 19 19" role="presentation"><path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path></svg></i> <a href="https://www.afterpay.com/purchase-payment-agreement" target="_blank" style="display: block;"><img src="https://static.afterpay.com/us-popup-medium.png" srcset="https://static.afterpay.com/us-popup-medium.png 1x, https://static.afterpay.com/us-popup-medium@2x.png 2x" style="max-width: 700px; display: block; width: 100%;" alt="Afterpay"></a>  </div>';
          
          // Popup for Klarna
          //htmlStr += '<div class="bpplpopup-modal shadow" data-popup-modal="pklarna"><i class="bpplpopup-modal__close"><svg focusable="false" class="icon icon--close " viewBox="0 0 19 19" role="presentation"><path d="M9.1923882 8.39339828l7.7781745-7.7781746 1.4142136 1.41421357-7.7781746 7.77817459 7.7781746 7.77817456L16.9705627 19l-7.7781745-7.7781746L1.41421356 19 0 17.5857864l7.7781746-7.77817456L0 2.02943725 1.41421356.61522369 9.1923882 8.39339828z" fill="currentColor" fill-rule="evenodd"></path></svg></i><a href="https://www.klarna.com/us/business/products/installments" target="_blank" style="display: block;"><img src="https://cdn.shopify.com/s/files/1/0806/1189/files/klarna-popup-img.png?v=1619243795"  style="max-width: 650px; display: block; width: 100%;" alt="Klarna"></a></div>'
          
          
          //add html into end of body
          var d = document.createElement("div");
          d.innerHTML = htmlStr;
          document.body.appendChild(d);
          
        },
        popupInitializations:function(){
        
          	const modalTriggers = document.querySelectorAll('.popup-trigger')
            const modalCloseTrigger = document.querySelector('.bpplpopup-modal__close')
            const bodyBlackout = document.querySelector('.bpplbody-blackout')

            modalTriggers.forEach(trigger => {
              trigger.addEventListener('click', () => {
                const { popupTrigger } = trigger.dataset
                const popupModal = document.querySelector(`[data-popup-modal="${popupTrigger}"]`)

                popupModal.classList.add('is--visible')
                bodyBlackout.classList.add('is-blacked-out')

                popupModal.querySelector('.bpplpopup-modal__close').addEventListener('click', () => {
                   popupModal.classList.remove('is--visible')
                   bodyBlackout.classList.remove('is-blacked-out')
                })

                bodyBlackout.addEventListener('click', () => {
                  // TODO: Turn into a function to close modal
                  popupModal.classList.remove('is--visible')
                  bodyBlackout.classList.remove('is-blacked-out')
                })
              })
            });
        
        }
        
      }
     
      window["bppayLaterFunction"] = cls;
      
   		if(theme.pageType == "product"){
      		cls.initProductPage();
  		}
      cls.initCartDrawerPage();
      cls.addPopupModalHtmls();
  	  cls.popupInitializations();
      
    };
    
    
    bppayLaterFunction();
    
    
  })();
  
  function shopapayclick(){document.getElementsByTagName('shopify-payment-terms')[0].shadowRoot.querySelector('#shopify-installments-cta').click();}
/*  KLARNA SHOP PAY AFTER PAY SCRIPT END  */

/*--- COUNTRY BASD ON IP IDENTIFICATIO ---*/    
window.visitorCountryKey = "mycountrypro";
window.visitorStateProvinceKey = "mystatepro";
window.iplookdomain = "https://geoip.sezzle.com/v1/geoip/ipdetails";

function addCountryTag(countryCode){
    document.body.classList.add("cusCntCode" + countryCode);
}
function addDynamicCssForCountryRestriction(){
  	// body tag with cusCntCodeSG with product's metafields, on section  [data-section-type="product"] .   
  	var curVisitorCountry = localStorage.getItem(window.visitorCountryKey);
  	//debugger
  if(document.querySelector("section[data-section-type='product']") != null){
  	document.querySelector("section[data-section-type='product']").classList.forEach(function(d){ 
    	// matches the SAME country, Restirction on section & The visitor's current country. Then append the CSS to hide product ATC button.
      	if(d == "block" + curVisitorCountry){
          	var targetEle = 'body.cusCntCode'+ curVisitorCountry +' section.block'+ curVisitorCountry +' .product-form__payment-container';
      		//var css = 'body.cusCntCode'+ curVisitorCountry +' section.'+ d +' .product-form__payment-container [type="submit"]{display: none;}  section .rebuy-bundle__actions {visibility: hidden;}';
          	var css = 'body.cusCntCode'+curVisitorCountry+' .block'+ curVisitorCountry +' [type="submit"], body.cusCntCode'+curVisitorCountry+' .block'+curVisitorCountry+' [data-action="open-modal"] {visibility:hidden} section .rebuy-bundle__actions {visibility: hidden;}';
          	var s = document.createElement("style");
          	s.innerText = css;
          	document.body.append(s);
          
  			if(document.querySelector(targetEle) != null)
          		document.querySelector(targetEle).innerHTML = "<b>We can not ship this product to the "+ curVisitorCountry +". </b>"
      	}	                                                                                                
    });  
  }else{
  		// For collection page
    		var targetEle = 'body.cusCntCode'+ curVisitorCountry +' section.block'+ curVisitorCountry +' .product-form__payment-container';
      		//var css = 'body.cusCntCode'+ curVisitorCountry +' section.'+ d +' .product-form__payment-container [type="submit"]{display: none;}  section .rebuy-bundle__actions {visibility: hidden;}';
          	var css = 'body.cusCntCode'+curVisitorCountry+' .block'+ curVisitorCountry +' [type="submit"], body.cusCntCode'+curVisitorCountry+' .block'+curVisitorCountry+' [data-action="open-modal"] {visibility:hidden} section .rebuy-bundle__actions {visibility: hidden;}';
          	var s = document.createElement("style");
          	s.innerText = css;
          	document.body.append(s);
  }	
}

function PrintOrderDiv() 
{  
       var divContents = document.getElementById("printmyorder").innerHTML;  
       var printWindow = window.open(window.location.href,'','height=500,width=600');  
       printWindow.document.write('<html><head><title>Order Print</title><style>body {font-family: "DIN Next", "Roboto", sans-serif;}</style>');  
       printWindow.document.write('</head><body >');  
       printWindow.document.write(divContents);  
       printWindow.document.write('</body></html>');  
       printWindow.document.close();  
       printWindow.print();  
       //printWindow.close();  
}

(function(){
  
    // check for products & their tags, if california related cookie exists then display warning.
    if(theme.pageType == "index"){
    	localStorage.removeItem(window.visitorCountryKey);
    }
    
    if(localStorage.getItem(window.visitorCountryKey) == undefined){
      
      	fetch(window.iplookdomain)
        .then(response => response.json())
        .then(data => { 
              
              	let json = data;
             	if(json.country_iso_code && json.city){
                  	localStorage.setItem(window.visitorCountryKey,json.country_iso_code);
                  	addCountryTag(json.country_iso_code);
                  
                    if(json.city.toLowerCase() == "california" || json.region_name.toLowerCase() == "california"){
                        localStorage.setItem(window.visitorStateProvinceKey,"california");                    	
                    }else{
                    	localStorage.setItem(window.visitorStateProvinceKey,json.region_name.toLowerCase());                      	
                	}
                  
                  if(theme.pageType == "product" || theme.pageType == "collection"){
                      addDynamicCssForCountryRestriction();
                  }
                  
            	}
    		}
            );
        }else{
        	addCountryTag(localStorage.getItem(window.visitorCountryKey));
          	if(theme.pageType == "product" || theme.pageType == "collection"){
            	addDynamicCssForCountryRestriction();
            }
        }
    
 })();
/*-- END COUNTRY IDENTIFICATION BASED ON IP --*/

